import React from "react";
import NavbarTop from "../components/NavbarTop";
import ScanDevice from "../components/ScanDevice";
import NavbarBottom from "../components/NavbarBottom";

const Dashboard = () => {
  return (
    <div>
      <NavbarTop />
      <ScanDevice />
      <NavbarBottom />
    </div>
  );
};

export default Dashboard;
